/**
 * Show details for one Launch agent.
 */

import {Alert} from '@wandb/weave/components/Alert';
import React, {useEffect} from 'react';
import {useParams} from 'react-router';

import {setDocumentTitle} from '../../../util/document';
import {cleanTabName} from '../../../util/string';
import {SemanticLoader as Loader} from '../../utility/InstrumentedLoader';
import * as S from './AgentDetailContent.styles';
import {AgentDetailHeader} from './AgentDetailHeader';
import {AgentDetailTabContent} from './AgentDetailTabContent';
import {AgentDetailTabs} from './AgentDetailTabs';
import {useAgent} from './hooks';

type AgentDetailContentParams = {
  entityName: string;
  agentId: string;
  tab?: string;
};

export const AgentDetailContent = () => {
  const {
    entityName,
    agentId,
    tab = 'overview',
  } = useParams<AgentDetailContentParams>();

  const {agent, error, loading} = useAgent(agentId);

  const pageTitle = agent?.name
    ? `Agent - ${agent.name} - ${cleanTabName(tab)}`
    : 'Agent';
  useEffect(() => {
    setDocumentTitle(pageTitle);
  }, [pageTitle]);

  if (error) {
    return <Alert severity="error">Error fetching agent details</Alert>;
  }
  if (loading || !agent) {
    return <Loader active size="large" name="agent-detail-loader" />;
  }

  return (
    <S.Panel>
      <AgentDetailHeader entityName={entityName} agent={agent} />
      <AgentDetailTabs entityName={entityName} agentId={agentId} tab={tab} />
      <S.Spacer />
      <AgentDetailTabContent entityName={entityName} agent={agent} tab={tab} />
    </S.Panel>
  );
};
